import { render, staticRenderFns } from "./NewsletterSection.vue?vue&type=template&id=fdaa0594&scoped=true"
import script from "./NewsletterSection.vue?vue&type=script&lang=js"
export * from "./NewsletterSection.vue?vue&type=script&lang=js"
import style0 from "./NewsletterSection.vue?vue&type=style&index=0&id=fdaa0594&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaa0594",
  null
  
)

export default component.exports